import * as actionTypes from './actionTypes'

// str -> str -> obj -> Action
const createAction = model => actionType => {
  const actionCreator = (payload?, meta = {}) => {
    const action = {
      type: actionType,
      meta: { model, pk: null, ...meta },
      payload,
    }
    if (
      payload != null &&
      (typeof payload === 'object' || typeof payload === 'function')
    ) {
      const { pk = null, ...data } = payload
      action.meta.pk = pk
      action.payload = data
    }
    return action
  }

  actionCreator.toString = () => actionType
  actionCreator.type = actionType
  return actionCreator
}

// str -> str
const camelCase = name =>
  name.toLowerCase().replace(/[- _]+(\w)/g, m => m[1].toUpperCase())

type CamelCase<S extends string> = S extends `${infer Head}_${infer Tail}`
  ? `${Lowercase<Head>}${Capitalize<CamelCase<Tail>>}`
  : Lowercase<S>

type ModelActions = Record<
  CamelCase<keyof typeof actionTypes>,
  ReturnType<ReturnType<typeof createAction>>
>

// object of action creators for named model
// str -> {str: obj -> Action}
export const modelActions = (model): ModelActions =>
  Object.fromEntries(
    Object.entries(actionTypes).map(([name, actionType]) => [
      camelCase(name),
      createAction(model)(actionType),
    ]),
  ) as ModelActions
